import React from 'react';
import PropTypes from 'prop-types';

import { IoMdVideocam } from 'react-icons/io';
import MessagesVideoModal from './MessagesVideoModal';

export default class MessagesVideoControl extends React.Component {
  static propTypes = {
    fileUpload: PropTypes.func.isRequired,
    refreshEverything: PropTypes.func.isRequired,
    myClient: PropTypes.object.isRequired,
  };

  state = {
    showVideoModal: false,
  };

  videoModalToggle = () => {
    this.setState((prevState) => ({
      showVideoModal: !prevState.showVideoModal,
    }));
  };

  // showVideoModal = () => this.setState({ showVideoModal: true });
  // hideVideoModal = () => this.setState({ showVideoModal: false });

  render() {
    return (
      <>
        <button
          onClick={this.videoModalToggle}
          className="btn btn-outline-primary ml-2 d-none d-sm-block"
          title="Record video to send to client"
          type="button"
        >
          <h4 className="d-flex mb-0">
            <IoMdVideocam />
          </h4>
        </button>
        {this.state.showVideoModal ? (
          <MessagesVideoModal
            videoModalToggle={this.videoModalToggle}
            isVideoModalOpen={this.state.showVideoModal}
            fileUpload={this.props.fileUpload}
            refreshEverything={this.props.refreshEverything}
            myClient={this.props.myClient}
          />
        ) : null}
      </>
    );
  }
}
